import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

/**
 * Editor for the up-to-2 "extra" delivery destinations in an SPB (multi-drop).
 * Combined with the primary customer above, an SPB can serve up to 3 pelanggans.
 *
 * Props:
 *   items:    array of { nama, alamat, _uid? }   (2 max)
 *   onChange: (nextItems) => void
 */
export default function ExtraPelanggansEditor({ items, onChange }) {
  const update = (idx, patch) => {
    const next = [...items];
    next[idx] = { ...next[idx], ...patch };
    onChange(next);
  };
  const remove = (idx) => onChange(items.filter((_, i) => i !== idx));
  const add = () => onChange([
    ...items,
    {
      nama: "", alamat: "",
      _uid: `pel_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    },
  ]);

  return (
    <>
      {items.map((p, idx) => (
        <div
          key={p._uid || idx}
          className="border-2 border-dashed border-border p-4 space-y-3 bg-secondary/20"
          data-testid={`extra-pelanggan-${idx}`}
        >
          <div className="flex items-center justify-between">
            <div className="overline text-xs">Tujuan Tambahan #{idx + 2}</div>
            <button
              type="button"
              onClick={() => remove(idx)}
              className="text-xs text-destructive uppercase font-bold tracking-wider hover:underline"
              data-testid={`remove-extra-pelanggan-${idx}`}
            >
              Hapus
            </button>
          </div>
          <div>
            <Label className="overline block mb-2">Nama Pelanggan #{idx + 2}</Label>
            <Input
              value={p.nama}
              onChange={(e) => update(idx, { nama: e.target.value })}
              placeholder="Nama penerima tambahan"
              className="rounded-none h-11"
              data-testid={`input-extra-nama-${idx}`}
            />
          </div>
          <div>
            <Label className="overline block mb-2">Alamat #{idx + 2}</Label>
            <Textarea
              value={p.alamat}
              onChange={(e) => update(idx, { alamat: e.target.value })}
              placeholder="Alamat lokasi bongkar tambahan"
              className="rounded-none min-h-[70px]"
              data-testid={`input-extra-alamat-${idx}`}
            />
          </div>
        </div>
      ))}

      {items.length < 2 && (
        <button
          type="button"
          onClick={add}
          className="w-full py-3 border-2 border-dashed border-border text-sm font-bold uppercase tracking-wider text-muted-foreground hover:border-primary hover:text-primary transition-colors"
          data-testid="add-extra-pelanggan"
        >
          + Tambah Tujuan {items.length === 0 ? "Kedua" : "Ketiga"} (Multi-Drop)
        </button>
      )}
    </>
  );
}
